// the project's folder is one project_source row: PUT changes it, POST makes the first one

export interface FolderRequest {
    method: 'POST' | 'PUT';
    data: { source_id?: number; folder_paths: string[] };
}

export function folderRequest(sourceId: number | null, path: string): FolderRequest {
    if (sourceId === null) return { method: 'POST', data: { folder_paths: [path] } };
    return { method: 'PUT', data: { source_id: sourceId, folder_paths: [path] } };
}
